import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { getChronicPovertyPanelDisplay } from '../../../utils/pobrezaCronicaDisplay';
import {
  LOT_INFO_FIELD_ROW_SX,
  LotInfoMetricIndicator,
  lotInfoFieldLabelLayoutSx,
  lotInfoFieldValueSx,
} from './formBlockUi';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      textAlign: 'center',
      maxWidth: 300,
      whiteSpace: 'normal',
      fontSize: '12px',
      lineHeight: 1.4,
    },
  },
};

/**
 * Fila de pobreza crónica (`chronic_poverty_pct`). Se usa dentro de LotRiesgosSection.
 */
const LotPobrezaCronicaSection = ({ chronicPovertyPct = null }) => {
  const display = getChronicPovertyPanelDisplay(chronicPovertyPct);

  return (
    <Box sx={LOT_INFO_FIELD_ROW_SX}>
      <Typography sx={lotInfoFieldLabelLayoutSx()}>
        Pobreza crónica
      </Typography>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '7px',
        }}
      >
        <Tooltip
          title={display.tooltip}
          placement="top"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '7px',
              maxWidth: '100%',
              cursor: 'help',
            }}
          >
            <LotInfoMetricIndicator color={display.accentColor} />
            {display.level && (
              <Typography component="span" sx={lotInfoFieldValueSx({ muted: true })}>
                {display.level}
              </Typography>
            )}
            <Typography
              component="span"
              sx={lotInfoFieldValueSx({ monospace: true })}
            >
              {display.pctLabel}
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default LotPobrezaCronicaSection;
